import { Injectable } from '@angular/core';

import { StorageService } from '@uoa/auth';

@Injectable({
  providedIn: 'root',
})
export class AppStorageService implements StorageService {
  getItem(key: string): Promise<unknown> {
    const item = window.localStorage.getItem(key);
    if (item === null) {
      return Promise.resolve(null);
    }

    try {
      return Promise.resolve(JSON.parse(item));
    } catch {
      return Promise.resolve(item);
    }
  }

  setItem(key: string, val: unknown): Promise<void> {
    const valueToStore = typeof val === 'string' ? val : JSON.stringify(val);
    window.localStorage.setItem(key, valueToStore);
    return Promise.resolve();
  }

  removeItem(key: string): void {
    window.localStorage.removeItem(key);
  }
}
